module.exports = __webpack_public_path__ + "static/img/rds.15133b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/rds.png
// module id = wOuQ
// module chunks = 0